import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import BtnNext from '../Buttons/BtnNext';
import BtnPrev from '../Buttons/BtnPrev';
import CourseMenu from './CourseMenu';
import fixPoetName from '../../helpers/fixPoetName.js';
import fixPoemName from '../../helpers/fixPoemName.js';

function CourseHeader(props){  
  let {poet, poem, id} = props.course.url

  const poetCap = fixPoetName(poet);
  const poemCap = fixPoemName(poem);

  document.title = poemCap + ' - ' + poetCap + ' | Close Reading';

  function parseHeader() {
    return [
      <Breadcrumb.Item key= '1'><Link to={"/poet/" + poet}>
        {poetCap}
      </Link></Breadcrumb.Item>,
      <Breadcrumb.Item key = '2'><a onClick={() => props.changeLesson(1)}>
        {poemCap}
      </a></Breadcrumb.Item>,
      <Breadcrumb.Item key = '3'>
        {id}
      </Breadcrumb.Item>
    ]
  }

  return (
    <header id="CourseHeader">
      <Link to="/"><h1 id="course-title">Close Reading</h1></Link>
      <div id="nav">
        <Breadcrumb>
          {parseHeader()}
        </Breadcrumb>
      </div>
      <div id="course-nav">
        <ul>
          <li><BtnPrev onClick={props.changeLesson} id={id} /></li>
          <li><h3>Lesson {id}</h3></li>
          <li><BtnNext onClick={props.changeLesson} length={props.course.length} id={id} /></li>
        </ul>
      </div>
      <CourseMenu course={props.course} logOut={props.logOut}/>
      <div className="clear"></div>
    </header>
  )
}

export default CourseHeader;



// WEBPACK FOOTER //
// ./src/components/Course/CourseHeader.js